import {ChangeDetectionStrategy, Component, effect, EffectRef, input, InputSignal, output, OutputEmitterRef, signal, untracked, WritableSignal} from '@angular/core';
import {ItemDocumentsPreviewSelectedComponent} from "../item-documents-preview-selected/item-documents-preview-selected.component";
import {ItemDocumentsPreviewAvailableComponent} from "../item-documents-preview-available/item-documents-preview-available.component";
import {FormLabelComponent} from "../../../shared/elements/form-label/form-label.component";
import {TranslatePipe} from "../../../shared/pipes/translate.pipe";
import {FileStorageResource} from '../../../shared/types/settings-types/fileStorageResource';

@Component({
    selector: 'app-document-selector',
    imports: [ItemDocumentsPreviewSelectedComponent, ItemDocumentsPreviewAvailableComponent, FormLabelComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
  <div class="document-selector-container d-flex flex-column">
    <app-form-label 
      [label]="'DOCUMENTSSELECTEDTITLE' | translate" 
      [class]="'mt-3'"
      >
    </app-form-label>
    <div class="document-selector-selected d-flex flex-row flex-wrap gap-2 mt-2">
      @if(_selectedFiles().length === 0) {
        <app-form-label 
          [label]="'NODOCUMENTSSELECTED' | translate" 
          [class]="'text-primary mx-auto mt-3'"
          >
        </app-form-label>
      } @else {
        @for(file of _selectedFiles(); track $index) {
          <app-item-documents-preview-selected 
            [file]="file"
            [files]="_selectedFiles()"
            (filesChange)="fileUnselect($event)"
            [position]="$index"
            [removeBadge]="'unselect'" 
            >
          </app-item-documents-preview-selected>
        }
      }
    </div>
    <app-form-label 
      [label]="'DOCUMENTSUNSELECTEDTITLE' | translate" 
      [class]="'mt-3'"
      >
    </app-form-label>
    <div class="document-selector-unselected d-flex flex-row flex-wrap gap-2 mt-2">
      @if(_unselectedFiles().length === 0) {
        <app-form-label 
          [label]="'NODOCUMENTSUNSELECTED' | translate" 
          [class]="'text-primary mx-auto mt-3'"
          >
        </app-form-label>
      } @else {
        @for(file of _unselectedFiles(); track $index) {
          <app-item-documents-preview-available
            [file]="file"
            [files]="_unselectedFiles()"
            (filesChange)="fileSelect($event)"
            >
          </app-item-documents-preview-available>
        }
      }
    </div>
  </div>
  `,
    styleUrl: './document-selector.component.scss'
})
export class DocumentSelectorComponent {

  public files: InputSignal<FileStorageResource[]> = input.required();
  public initialySelected: InputSignal<boolean> = input(true);
  public selectedFiles: OutputEmitterRef<FileStorageResource[]> = output();

  public _selectedFiles: WritableSignal<FileStorageResource[]> = signal([]);
  public _unselectedFiles: WritableSignal<FileStorageResource[]> = signal([]);
  
  private setPreselectionEffect: EffectRef = effect(() => {
    if(this.files().length > 0) {
      if(this.initialySelected()) {
        untracked(() => {
          this._selectedFiles.set([...this.files()]);
          this._unselectedFiles.set([]);
        });
      } else {
        untracked(() => {
          this._selectedFiles.set([]);
          this._unselectedFiles.set([...this.files()]);
        });
      }
    }
  });

  public fileUnselect(updatedFiles: FileStorageResource[]): void {
    this._selectedFiles.set(updatedFiles);
    this._unselectedFiles.set(this.files().filter(file => !this._selectedFiles().some(selected => selected.id === file.id)));
    this.selectedFiles.emit(this._selectedFiles());
  }

  public fileSelect(updatedFiles: FileStorageResource[]): void {
    this._unselectedFiles.set(updatedFiles);
    this._selectedFiles.set(this.files().filter(file => !this._unselectedFiles().some(unselected => unselected.id === file.id)));
    this.selectedFiles.emit(this._selectedFiles());
  }
}
